import { FC } from 'react';
import { v4 as uuid } from 'uuid';
import { MENTION_DASHBOARD_CHANNEL } from 'types/dashboard.types';
import './DashboardTabs.scss';

interface IDashboardTab {
  tabId: number;
  tabName: string;
  variant?: MENTION_DASHBOARD_CHANNEL;
}

interface IDashboardTabs {
  tabsList: IDashboardTab[];
  selectedTabId: number;
  handleChangeSelectedTabId: (newTabId: number) => void;
}

const DashboardTabs: FC<IDashboardTabs> = ({ tabsList, handleChangeSelectedTabId, selectedTabId }: IDashboardTabs) => {
  const generateTabs = (tabsList: IDashboardTab[]) => {
    return tabsList.map(tab => {
      const isSelected = selectedTabId === tab.tabId;
      const isCustomerChatSelected = isSelected && tab.variant === MENTION_DASHBOARD_CHANNEL.CUSTOMER_CHAT;

      return (
        <div
          key={uuid()}
          onClick={() => handleChangeSelectedTabId(tab.tabId)}
          className={`dashboardTab ${isSelected ? 'selected' : ''} ${isCustomerChatSelected ? 'selectedCustomerChat' : ''}`}
        >
          <div className="tabName">{tab.tabName}</div>
        </div>
      );
    });
  };

  return <div className="DashboardTabs">{tabsList && tabsList.length > 0 && generateTabs(tabsList)}</div>;
};

export default DashboardTabs;
